import API from '../../services/API'
import {
    DOCUMENTS_GETTER,
    DOCUMENTS_MUTATION_ENTIRE_DOCUMENTS,
    DOCUMENTS_MUTATION_PHOTOS,
    DOCUMENTS_ACTION_GET_DOCUMENTS,
    DOCUMENTS_ACTION_UPLOAD_FILE,
    DOCUMENTS_ACTION_DELETE_FILE,
    DOCUMENTS_TYPE_PHOTO,
    DOCUMENTS_TYPE_GENERAL_DOCUMENT,
    DOCUMENTS_TYPE_VIDEO
} from './documents-types'
import Vue from 'vue'
import OAlert from '../../utils/OAlert/OAlert'
import i18n from '../../assets/i18n/lang'

export default {
    namespaced: true,

    state: {
        documents: {}
    },

    getters: {
        [DOCUMENTS_GETTER]: state => state.documents
    },

    mutations: {
        [DOCUMENTS_MUTATION_ENTIRE_DOCUMENTS] (state, payload) { state.documents = payload },
        [DOCUMENTS_MUTATION_PHOTOS] (state, payload) { Vue.set(state.documents.photos, payload.index, payload) }
    },

    actions: {
        [DOCUMENTS_ACTION_GET_DOCUMENTS] ({ commit }) {
            API.loadDocuments()
                .then((documentsData) => {
                    let photos = documentsData.photos
                    let tempPhotos = []
                    let counter = 0
                    let photosCount = photos.length
                    for (let i in documentsData.photos) {
                        API.downloadFile(photos[i].name, photos[i].url)
                            .then((data) => {
                                counter++
                                photos[i].index = i
                                photos[i].blob = data
                                photos[i].oURL = URL.createObjectURL(data)
                                photos[i].orientation = i
                                tempPhotos.push(photos[i])
                                if (counter === photosCount) {
                                    tempPhotos.sort(function (a, b) {
                                        return b.id > a.id ? 1
                                            : b.id < a.id ? -1
                                                : 0
                                    })
                                    documentsData.photos = tempPhotos
                                    commit(DOCUMENTS_MUTATION_ENTIRE_DOCUMENTS, documentsData)
                                }
                            })
                            .catch((error) => {
                                counter++
                                console.log('' + error.message)
                            })
                    }
                })
                .catch((error) => {
                    console.log('' + error.message)
                })
        },
        [DOCUMENTS_ACTION_UPLOAD_FILE] ({commit, dispatch, state}, payload) {
            API.uploadFile(payload.filename, payload.file)
                .then((snapshot) => {
                    if (payload.type === DOCUMENTS_TYPE_PHOTO) {
                        let filename = snapshot.metadata.name
                        let newFilename = 'proc_' + filename
                        let fullpath = snapshot.metadata.fullPath.replace(filename, newFilename)
                        return API.addPhoto(payload.filename, fullpath)
                    } else if (payload.type === DOCUMENTS_TYPE_GENERAL_DOCUMENT) {
                        return API.addDocument(payload.filename, snapshot.metadata.fullPath)
                    } else if (payload.type === DOCUMENTS_TYPE_VIDEO) {
                        return API.addVideo(payload.filename, snapshot.metadata.fullPath)
                    }
                })
                .then((response) => {
                    OAlert.showSuccess('', i18n.t('feedback.fileSucUpload'))
                    setTimeout(function () { dispatch(DOCUMENTS_ACTION_GET_DOCUMENTS) }, 6000)
                    dispatch(DOCUMENTS_ACTION_GET_DOCUMENTS)
                })
                .catch((error) => console.log('' + error.message))
        },
        [DOCUMENTS_ACTION_DELETE_FILE] ({commit, dispatch, state}, payload) {
            if (payload.type === DOCUMENTS_TYPE_PHOTO) {
                API.deletePhotoFromBackend(payload.id)
                    .then((response) => {
                        OAlert.showSuccess('', i18n.t('feedback.photoSucDelete'))
                        dispatch(DOCUMENTS_ACTION_GET_DOCUMENTS)
                    })
                    .catch((error) => console.log(error.message))
            } else if (payload.type === DOCUMENTS_TYPE_GENERAL_DOCUMENT) {
                API.deleteGenDocFromBackend(payload.id)
                    .then((response) => {
                        OAlert.showSuccess('', i18n.t('feedback.fileSucDelete'))
                        dispatch(DOCUMENTS_ACTION_GET_DOCUMENTS)
                    })
                    .catch((error) => console.log(error.message))
            } else if (payload.type === DOCUMENTS_TYPE_VIDEO) {
                API.deleteVideoFromBackend(payload.id)
                    .then((response) => {
                        OAlert.showSuccess('', i18n.t('feedback.fileSucDelete'))
                        dispatch(DOCUMENTS_ACTION_GET_DOCUMENTS)
                    })
                    .catch((error) => console.log(error.message))
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/documents.js